import { getUrlQueryParams } from '.'
import { sitePath } from '@config'

export const formatQuestionAndAnswers = (questions) => {
  if (!questions) return null

  return questions?.map((question) => ({
    id: question?.id,
    question: question?.questionAndAnswers?.question,
    answers: [
      {
        answer: question?.questionAndAnswers?.answerA,
        points: question?.points?.answerAPoints || {},
      },
      {
        answer: question?.questionAndAnswers?.answerB,
        points: question?.points?.answerBPoints || {},
      },
      {
        answer: question?.questionAndAnswers?.answerC,
        points: question?.points?.answerCPoints || {},
      },
    ],
  }))
}

export const initAssassinScores = (assassins) => {
  return assassins?.reduce((acc, assassin) => {
    return {
      ...acc,
      ...(assassin?.assassinId
        ? { [assassin?.assassinId.replace(' ', '')]: 0 }
        : {}),
    }
  }, {})
}

export const answerFromEmail = () => {
  const urlQueryParams = getUrlQueryParams()
  const answer = urlQueryParams?.answer

  return answer === '0' || answer === '1' || answer === '2' ? answer : null
}

export const slugify = (string) => {
  return string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase()
}

export const getLocalizedSitePath = (locale = 'en-us') => {
  return `/${locale.toLowerCase()}${sitePath || ''}`
}

export const getAssassinResultsSlug = (assassinId, locale) => {
  if (!assassinId) return null

  const slug = slugify(assassinId)
  const localizedSlug = getLocalizedSitePath(locale) + '/' + slug

  return localizedSlug
}

export const getLanguageAndCountry = (locale = 'en-US') => {
  const [language, country] = locale.toUpperCase().split('-')
  return { language, country }
}
